import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, Fragment, useState } from 'react';
import ElementorBanner from '../Common/ElementorBanner';
import UISpinner from '../../shared/UIComponents/UISpinner';
import ElementorMeetingWarning from './ElementorMeetingWarning';
import { MeetingsContext } from '../../shared/Meeting/MeetingsContext';
import useMeetings, { useSelectedMeetingCalendar, } from '../../shared/Meeting/useMeetings';
import { __ } from '@wordpress/i18n';
export default function ElementorMeetingSelect({ url, setAttributes, }) {
    const { loading, error, reload } = useContext(MeetingsContext);
    const meetings = useMeetings();
    const selectedMeetingCalendar = useSelectedMeetingCalendar();
    const [localUrl, setLocalUrl] = useState(url);
    return (_jsx(Fragment, { children: loading ? (_jsx("div", { children: _jsx(UISpinner, {}) })) : error ? (_jsx(ElementorBanner, { type: "danger", children: __('Please refresh your meetings or try again in a few minutes.', 'leadin') })) : (_jsxs(Fragment, { children: [selectedMeetingCalendar && (_jsx(ElementorMeetingWarning, { status: selectedMeetingCalendar, triggerReload: () => reload() })), meetings.length > 1 && (_jsxs("select", { value: localUrl, onChange: event => {
                        const newUrl = event.target.value;
                        setLocalUrl(newUrl);
                        setAttributes({
                            url: newUrl,
                        });
                    }, children: [_jsx("option", { value: "", disabled: true, selected: true, children: __('Select a meeting', 'leadin') }), meetings.map(item => (_jsx("option", { value: item.value, children: item.label }, item.value)))] }))] })) }));
}
